class LoadMorePaginationButton extends HTMLElement {
  constructor() {
    super();
    this.resultsLength = 0;
    this.articleResults = [];
    this.loading = false;
    this.paginateData = JSON.parse(document.querySelector('.load-more-pagination').dataset.paginate);
    this.totalPages = this.paginateData.pages;
    this.articleLimit = this.paginateData.page_size;
    this.page = 1;
  }

  connectedCallback() {
    this.blogLoadMore = this.querySelector('[blog-load-more]');
    this.blogLoadMoreBtn = this.querySelector('[blog-load-more] button');
    this.articlesContainer = document.getElementById('blog-more-articles-list');
    this.blogLoadMoreBtn.addEventListener('click', this.loadMoreArticles.bind(this));
  }

  loadMoreArticles() {
    if (!this.loading) {
      this.resultsLength = 0;
    }
    this.loadNextPage();
  }

  getArticles() {
    this.blogLoadMoreBtn.classList.add('loadingState');
    this.blogLoadMoreBtn.setAttribute('disabled', 'disabled');
    this.loading = true;
    const url = this.paginateData.next.url;
    this.controller = new AbortController();
    const signal = this.controller.signal;
    fetch(url, { signal })
      .then((response) => response.text())
      .then((html) => {
        const dom = new DOMParser().parseFromString(html, 'text/html');
        const articles = dom.getElementsByClassName('blogs__moreArticlesItem-card');
        this.articleResults = [...this.articleResults, ...articles];
        const newPaginationData = JSON.parse(dom.querySelector('.load-more-pagination').dataset.paginate);
        this.paginateData = newPaginationData;
        this.loadNextPage();
      })
      .catch((error) => {
        if (!error.message.includes('user aborted')) {
          HELPER_UTIL.dispatchCustomEvent(_EVENT_HELPER.triggerToastMessage, document, {
            toastType: 'common-errors',
            messageType: 'error',
            message: 'Something went wrong. Please try again',
          });
        }
        this.blogLoadMoreBtn.classList.remove('loadingState');
        this.blogLoadMoreBtn.removeAttribute('disabled');
        this.loading = false;
      });
  }

  loadNextPage() {
    const toPrint = this.articleResults.splice(0, this.articleLimit - this.resultsLength);
    toPrint.forEach((article) => {
      this.articlesContainer.appendChild(article);
    });
    this.resultsLength += toPrint.length;
    if (this.resultsLength < this.articleLimit && this.page < this.totalPages) {
      this.getArticles(++this.page);
      return;
    } else if (this.page == this.totalPages && this.articleResults.length == 0) {
      this.blogLoadMore.classList.add('complete');
    }
    this.blogLoadMoreBtn.classList.remove('loadingState');
    this.blogLoadMoreBtn.removeAttribute('disabled');
    this.loading = false;
  }
}
customElements.define('load-more-pagination', LoadMorePaginationButton);
